import { createSignal, createEffect } from "solid-js";
import { onMount } from "solid-js";
import DescriptionForm from "../components/forms/DescriptionForm";
import PrevInterview from "../components/home/PrevInterview";
import { userInterviews } from "../stores/userStore";
import { setRegion, setToken } from "../stores/userStore";
import { getAzureToken } from "../services/interviewActions/interviewService";
import profile from "../assets/profile.svg";
import User from "../components/home/User";

export default function Home() {
  const [loadedInterviewsCom, setLoadedInterviewsCom] = createSignal([]);
  const [loadedInterviewsInc, setLoadedInterviewsInc] = createSignal([]);
  const [userInfo, showUserInfo] = createSignal(false);

  onMount(async () => {
    // Get token and region for Azure services
    const { token, region } = await getAzureToken();
    setToken(token);
    setRegion(region);
  });

  createEffect(() => {
    const interviews = userInterviews();
    if (!interviews || interviews.length === 0) {
      setLoadedInterviewsInc([]);
      setLoadedInterviewsCom([]);
      return;
    }

    const inc = [];
    const com = [];

    // 1 - Not started, -1 - In progress, 0 - Complete
    // Sort interviews into incomplete and complete arrays
    interviews.forEach((interview) => {
      if (interview.status === 0) {
        com.push({
          ...interview,
          index: com.length,
        });
      } else {
        inc.push({
          ...interview,
          index: inc.length,
        });
      }
    });

    setLoadedInterviewsInc(inc);
    setLoadedInterviewsCom(com);
  });

  return (
    <div class="page">
      <div class="header">
        <h1 style="cursor: default;">mia</h1>
        <button
          class="icon-button"
          onMouseEnter={() => showUserInfo(true)}
          onMouseLeave={() => showUserInfo(false)}>
          <img class="generic-icon" src={profile} />
        </button>

        {userInfo() && (
          <div
            style="z-index: 9999;"
            class="user-popup"
            onMouseEnter={() => showUserInfo(true)}
            onMouseLeave={() => showUserInfo(false)}>
            <User></User>
          </div>
        )}
      </div>
      <div id="home-page-content-container">
        <div id="prev-interviews">
          <Show
            when={
              loadedInterviewsInc().length > 0 ||
              loadedInterviewsCom().length > 0
            }
            fallback={
              <div>
                <p style="font-size: 1.8em; align-self: center;">
                  Your interview list is empty.
                </p>
              </div>
            }>
            <Show
              when={loadedInterviewsCom().length > 0}
              fallback={<div>You have not completed any interviews yet!</div>}>
              <p style="font-size: 2.2em;">Completed Interviews</p>
              <For each={loadedInterviewsCom().reverse()}>
                {(interview) => (
                  <PrevInterview
                    index={interview.index}
                    id={interview._id}
                    name={interview.name}
                    date={interview.date}
                    thisInterview={interview}
                  />
                )}
              </For>
            </Show>
            <Show
              when={loadedInterviewsInc().length > 0}
              fallback={<div>No incomplete interviews.</div>}>
              <p style="font-size: 2.2em;">Incomplete Interviews</p>
              <For each={loadedInterviewsInc().reverse()}>
                {(interview) => (
                  <PrevInterview
                    index={interview.index}
                    id={interview._id}
                    name={interview.name}
                    date={interview.date}
                    thisInterview={interview}
                  />
                )}
              </For>
            </Show>
          </Show>
        </div>
        <div id="user-input">
          <DescriptionForm></DescriptionForm>
        </div>
      </div>
    </div>
  );
}
